import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.33301 2.5H17.3955",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.33301 17.5H17.3955",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.23926 15.2042V14.6004C7.2393 14.4498 7.28468 14.3026 7.36973 14.1772L9.71348 10.7333C9.78482 10.6285 9.88148 10.5426 9.99487 10.4831C10.1083 10.4237 10.2349 10.3926 10.3635 10.3926C10.4921 10.3926 10.6187 10.4237 10.7321 10.4831C10.8455 10.5426 10.9421 10.6285 11.0135 10.7333L13.3572 14.1772C13.4428 14.303 13.4885 14.4508 13.4885 14.6019V15.2042H7.23926Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.89551 17.5V14.6003C4.89552 13.9958 5.0782 13.4049 5.42051 12.902L8.02051 9.08163L5.42051 5.26122C5.0782 4.75834 4.89552 4.16744 4.89551 3.56301V2.5",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.833 2.5V3.56301C15.833 4.16744 15.6503 4.75834 15.308 5.26122L12.708 9.08163L15.308 12.902C15.6503 13.4049 15.833 13.9958 15.833 14.6003V17.5",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		})
	]
});
export default SvgTrack;
